export default __webpack_public_path__ + "static/media/Premiere.950a946d.png";